import ChartComponent from "./ChartComponent";
import D3Funnel from 'd3-funnel';
import React from 'react';

const Funnel = ({
    data,
    options,
    height,
    width,
    curved,
    pinched,
    gradient,
    inverted,
    highlightOnHover,
    showToolTips,
    dynamicHeight,
    barOverlay,
    animationSpeed,
    onClick = () => { },
}) => {

    function draw(chart) {
        const funnel = new D3Funnel(chart);
        funnel.draw(data, {
            ...options,
            chart: {
                ...options.chart,
                curve: { enabled: curved },
                ...(pinched ? { bottomPinch: 1 } : {}),
                inverted,
                ...(animationSpeed ? { animate: animationSpeed } : {})
            },
            block: {
                ...options.block,
                ...(gradient ? {
                    fill: {
                        type: 'gradient',
                    }
                } : {}),
                highlight: highlightOnHover,
                dynamicHeight,
                barOverlay,

            },
            tooltip: {
                enabled: showToolTips
            },
            events: {
                click: {
                    block(d) {
                        onClick(d);
                    }
                }
            }
        });
    }

    function update(chart) {
        const funnel = new D3Funnel(chart);
        funnel.draw(data, {
            ...options,
            chart: {
                ...options.chart,
                curve: { enabled: curved },
                ...(pinched ? { bottomPinch: 1 } : {}),
                inverted,
                ...(animationSpeed ? { animate: animationSpeed } : {})
            },
            block: {
                ...options.block,
                ...(gradient ? {
                    fill: {
                        type: 'gradient',
                    }
                } : {}),
                highlight: highlightOnHover,
                dynamicHeight,
                barOverlay,

            },
            tooltip: {
                enabled: showToolTips
            },
            events: {
                click: {
                    block(d) {
                        onClick(d);
                    }
                }
            }
        });
    }

    return <ChartComponent style={{ height, width }} useRef draw={draw} update={update} />
}

export default Funnel
